import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";

import { baseURL } from "../../constants/Api";
import axios from "axios";
import OrderCard from "./OrderCard";
import Skeleton from "../skeletons/skeleton";
import { messaging } from "../../pages/login/firebase/Firebase";
import { onMessage } from "firebase/messaging";

function OrderHistory(props) {
  const [historyArray, setHistoryArray] = useState([]);
  const reservationId = localStorage.getItem("reservationId");
  const appUserId = localStorage.getItem("appUserId");
  const [loading, setLoading] = useState(false);

  function closeModal() {
    props.hide();
  }

  const fetchHistory = async () => {
    setLoading(true);
    try {
      await axios({
        url: `${baseURL}/api/allServiceHistory`,
        method: "post",
        data: {
          reservationId: reservationId,
          appUserId,
        },
        headers: { "Content-Type": "application/json" },
      }).then(function (response) {
       console.log("history======================",response.data);
        if (response.data.success) {
          setLoading(false);
          setHistoryArray(response.data.data);
  
        }
      });
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };



    
const [DataFromApi,setDataFromApi] = useState([]);
const handleDataUpdate = (updatedData) => {
  let newStatus = 'Cancelled';
  const datafromHIs = historyArray;

  const updatedDatas = datafromHIs.map((item) =>
    item.id === updatedData ? { ...item, status: newStatus } : item
  );

  setHistoryArray(updatedDatas);
  console.log("Updated historyArray from first component:", updatedDatas);

  return updatedDatas; 
};

  return (
    <>
      <Transition appear show={true} as={Fragment}>
        <Dialog as="div" className="relative z-[999999]" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-md bg-[#171538] p-4 pt-2 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  ></Dialog.Title>
                  {!loading ? (
                    <div>
                      <div className="doc-modal flex-col items-center justify-center mt-2">
                        <div className="flex justify-center items-center"></div>
                        <div className="head mb-2">History / Status</div>
                      </div>
                      {historyArray?.length !== 0 ? (
                        historyArray.map((item, i) => (
                          <OrderCard key={i} historyData={item} onDataUpdate={(id)=>handleDataUpdate(id)}/>
                        ))
                      ) : (
                        <div className="p-3 bg-[#3a3268] text-xs text-white">
                          no order history found
                        </div>
                      )}
                      <div className="absolute top-2 right-2 ">
                        <button
                          type="button"
                          className="outline-none rounded-full hover:bg-indigo-700"
                          onClick={closeModal}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1"
                            stroke="white"
                            className="w-6 h-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  ) : (
                    <Skeleton type="modal" />
                  )}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}

export default OrderHistory;
